export default "__VITE_ASSET__DrBlcXSO__"